import { useQuery, useQueryClient } from "@tanstack/react-query";
import { RelabelCaseService } from "src/services/relabelCases";
import { queryKeys } from "src/constants";
import { RelabelCasePaginationOptions } from "src/types";

const useRelabelCases = (
  relabelCaseService: RelabelCaseService,
  paginationOptions: RelabelCasePaginationOptions,
  refetchInterval?: number
) => {
  const queryClient = useQueryClient();

  const {
    data: paginatedRelabelCases,
    error: fetchError,
    isLoading,
    isRefetching,
    isError,
    refetch
  } = useQuery({
    queryKey: queryKeys.paginatedRelabelCases(paginationOptions),
    queryFn: () => relabelCaseService.getRelabelCases(paginationOptions),
    refetchInterval,
    refetchIntervalInBackground: false
  });

  const refreshRelabelCases = () => {
    queryClient.removeQueries({ queryKey: queryKeys.paginatedRelabelCases(), exact: false });
  };

  return { paginatedRelabelCases, fetchError, isLoading, isRefetching, isError, refreshRelabelCases, refetch };
};

export { useRelabelCases };
